import { render, staticRenderFns } from "./ProfileSet.vue?vue&type=template&id=34a2f2ca&scoped=true&"
import script from "./ProfileSet.vue?vue&type=script&lang=js&"
export * from "./ProfileSet.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSet.vue?vue&type=style&index=0&id=34a2f2ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a2f2ca",
  null
  
)

export default component.exports